import React, { Component } from 'react';
import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';
import { MenuItem } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';

import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';

import ReactDropzone from 'react-dropzone';
import RenderDialog from '../../helpers/RenderDialog';

import upload from '../../images/upload.png';

import Layout from '../Layout';

import renderSelectField from '../../helpers/RenderSelectField';
import validationHelper from '../../helpers/ValidationHelper';

import getPerson from '../../actions/getPerson';
import searchByAttribute from '../../actions/searchByAttribute';
import postVxcPortfolioUpload from '../../actions/VXC/postVxcPortfolioUpload';

const styles = theme => ({
    card: {
        display: 'flex',
        boxShadow: 'none',
        justifyContent: 'center'
    },
    content: {
        display: 'flex'
    },
    contentAndMarginTop4: {
        display: 'flex',
        marginTop: '8%'
    },
    paperStyle: {
        width: '70%',
        height: '70%',
        display: 'inline-block',
        margin: 20,
        marginTop: '13vh',
        maxWidth: '1075px',
        minHeight: '476px'
    },
    buttonStyle: {
        marginTop: '11%',
        marginBottom: 28
    },
    textField: {
        width: 250,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    marginTop3: {
        marginTop: '3%'
    },
    availableReportHeader: {
        width: '100%',
        font: 'Roboto',
        fontSize: '16pt',
        textAlign: 'left',
        padding: '0',
        margin: '0',
        color: 'rgba(168, 169, 174, 1)'
    },
    availableReportDiv: {
        textAlign: 'center',
        margin: 'auto',
        color: 'grey',
        paddingTop: '10px'
    },
    dropBoxMessage: {
        fontSize: '18pt'
    },
    dropBoxMessageSpan: {
        color: '#002053',
        cursor: 'pointer'
    },
    fileUploadedMessage: {
        marginBottom: '5%'
    }
});

const validate = (values) => {
    const errors = validationHelper.validateRequired(['submissionType', 'portfolio'], values);
    return errors;
};

class Portfolio extends Component {
    state = {
        fileUploadedMessage: '',
        portfolios: [],
        fileUploaded: false,
        customer: [],
        message: '',
        portfolio: '',
        submissionType: '',
        saving: false,
        openDialog: false,
        failure: false,
        fileAttached: false

    };
    componentDidMount() {
        this.props.actions.getPortfolioDataList(this.props.data.config, this);
    }
    onDrop = (acceptedFiles) => {
        const fileExt = acceptedFiles[0].name.substr(acceptedFiles[0].name.length - 3, 3);
        if (fileExt.toLowerCase() === 'csv') {
            this.setState(() => {
                const files = [acceptedFiles];
                return { fileAttached: true, message: '', filesToUpload: files, fileUploadedMessage: (<p style={{ marginBottom: '5%' }}><span style={{ color: '#002053' }}>{acceptedFiles[0].name}</span> is ready for upload</p>) };
            });
        } else {
            this.setState({ openDialog: true, message: 'The file uploaded isn\'t valid for submission.  Please check the file type and try again.' })
        }
    };

    handleSave = (event) => {
        event.preventDefault();
        const portfolioInfo = this.state.portfolios.filter(portfolio => portfolio.portfolioId === this.state.portfolio)
        const filename = this.state.filesToUpload[0][0].name;
        this.setState({ saving: true })
        const portfolioData = {
            portfolioName: portfolioInfo[0].name,
            portfolioId: this.state.portfolio,
            submissionType: this.state.submissionType,
            fileName: filename
        }

        this.props.actions.postVxcPortfolio(this.state.filesToUpload[0], portfolioData, this.props.data.config, this);

        this.setState({ fileUploaded: true, fileUploadedMessage: '' });
    }

    handleSelectChange = (event) => {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleClose = () => {
        this.setState({ openDialog: false });
    }

    saveAlert = () => {
        let dialog = <div />;
        if (this.state.openDialog) {
            if (!this.state.failure && !this.state.message) {
                const successMessage = (
                    <div style={{ margin: '0 auto', textAlign: 'center' }}>
                        <img src="success.png" width="60" height="60" style={{ margin: '0 auto' }} alt="success" />
                        <h3>Success</h3>
                        <p>Your submission has been received</p>
                    </div>)
                dialog =
                    (<RenderDialog
                        open={this.state.openDialog}
                        confirmButton
                        message={successMessage}
                        onClose={this.handleClose}
                    />);
            } else if (this.state.message !== '') {
                dialog =
                    (<RenderDialog
                        open={this.state.openDialog}
                        confirmButton
                        message={this.state.message}
                        onClose={this.handleClose}
                    />)
            } else {
                const failureMessage = (
                    <div style={{ margin: '0 auto', textAlign: 'center' }}>
                        <img src="error.png" width="60" height="60" style={{ margin: '0 auto' }} alt="error" />
                        <h3>Error</h3>
                        <p>There is an issue with your submission</p>
                    </div>)
                dialog =
                    (<RenderDialog
                        open={this.state.openDialog}
                        confirmButton
                        message={failureMessage}
                        onClose={this.handleClose}
                    />);
            }
        } else {
            dialog = <div />
        }
        return dialog;
    }

    render() {
        if (this.state.filesToUpload) {
            console.log(this.state.filesToUpload[0]);
        }
        const dialog = this.saveAlert();
        const { fileUploadedMessage } = this.state;
        const { classes } = this.props;
        const portfolioOption = [];

        const portfolioTypeValues = this.state.portfolios.sort((a, b) => {
            if (a.name.toLowerCase() > b.name.toLowerCase()) {
                return 1;
            }
            if (a.name.toLowerCase() < b.name.toLowerCase()) {
                return -1;
            }
            return 0;
        })

        portfolioTypeValues.forEach((portfolio) => {
            portfolioOption.push(<MenuItem key={portfolio.portfolioId} value={portfolio.portfolioId}>{portfolio.name}</MenuItem>)
        });
        return (
            <Layout className="App" showMenu menuTitle="Portfolio" leftTitle="Report Manager" rightTitle="Submit File" toolTip="Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727." >
                <Paper className={classes.paperStyle}>
                    <Form onSubmit={this.handleSave}>
                    <p className="mandatory-msg">* - Denotes required fields</p>
                        <Card className={classes.card}>
                            <CardContent className={`${classes.content, classes.marginTop3}`}>
                                <Field
                                    name="submissionType"
                                    component={renderSelectField}
                                    label="*Submission Type"
                                    className={classes.textField}
                                    divClassName={classes.formControl}
                                    onChange={this.handleSelectChange}
                                >
                                    <MenuItem value="full">Full</MenuItem>
                                    <MenuItem value="delta">Delta</MenuItem>
                                </Field>
                                <Field
                                    name="portfolio"
                                    component={renderSelectField}
                                    label="*Portfolio"
                                    className={classes.textField}
                                    divClassName={classes.formControl}
                                    onChange={this.handleSelectChange}
                                >
                                    {portfolioOption}
                                </Field>
                            </CardContent>
                        </Card>
                        <Card className={classes.card}>
                            <CardContent className={classes.contentAndMarginTop4}>
                                <ReactDropzone
                                    onDrop={this.onDrop}
                                    className="dropzone"
                                >
                                    <div className={classes.availableReportDiv}>
                                        <img src={upload} alt="File Upload" width={100} height={67} />
                                        <br /><br />
                                        <p className={classes.dropBoxMessage}>Drag File Here or <span className={classes.dropBoxMessageSpan}>Browse</span></p>
                                        {fileUploadedMessage}
                                    </div>
                                </ReactDropzone>
                            </CardContent>
                        </Card>
                        <div className={classes.buttonStyle}>
                            <Button variant="raised" 
                            disabled={!this.props.valid || !this.state.fileAttached} 
                            style={this.props.valid && this.state.fileAttached ? { background: '#002053' } : { background: '#ddd' }} 
                            type="submit">Submit</Button>
                        </div>
                        {dialog}
                    </Form>
                </Paper>
            </Layout>
        );
    }
}

Portfolio.propTypes = {
    classes: PropTypes.shape().isRequired
};

const mapStateToProps = state => ({
    data: {
        customers: state.customers,
        config: state.config.config,
        person: state.person.person,
        login: state.login.login
    }
});

const mapDispatchToProps = dispatch => ({
    actions: {
        getPortfolioDataList: (config, self) => {
            dispatch(getPerson(null, self.props.data.login.sub, self.props.data.config)).then((result) => {
                if (result && result.action && result.action.payload && result.action.payload.data && result.action.payload.data.person) {
                    result.action.payload.data.person.locations.forEach((location) => {
                        if (location.locationId === localStorage.locationId) {
                            dispatch(searchByAttribute('portfolios', 0, 'customerId', location.customerId, config)).then((result1) => {
                                self.setState({ portfolios: result1.value.data.items, fetching: false });
                            });
                        }
                    });
                }
            });
        },
        postVxcPortfolio: (acceptedFiles, portfolioData, config, self) => {
            dispatch(postVxcPortfolioUpload(acceptedFiles, portfolioData, config)).then((p) => {
                self.setState({ saving: false, openDialog: true })
            }).catch((error) => {
                self.setState({ saving: false, failure: true, openDialog: true })
            });
        }
    }
});

const ConnectedPortfolio = connect(
    mapStateToProps,
    mapDispatchToProps
)(Portfolio);

export default withStyles(styles, { withTheme: true })(reduxForm({ form: 'PortfolioForm', validate })(ConnectedPortfolio));


// WEBPACK FOOTER //
// ./src/components/Portfolio/Portfolio.js